﻿import React from 'react';
import {connect} from 'react-redux';

import styled from 'styled-components';
import definitions from '../../../Style/LfStyleDefinitions';
import {iconCode, mediaQuery, clearFix} from '../../../Style/cssHelpers';

import {statusDefinitions} from '../PreregStatusDefs/status';

export default function StatusBlock({ status }) {
    return (
        <StatusBlockWrapper statusColor={statusDefinitions[status].color}>
            <h5>Status</h5>
            {statusDefinitions[status].statusCopy}
        </StatusBlockWrapper>                
    );
}

// styles 

const StatusBlockWrapper = styled.div` 
    position: relative; 

    font-size: 18px; 
    ${mediaQuery.large(`
        font-size: 16px;
    `)}

    ${mediaQuery.small(`
        margin-left: 12px;
    `)}

    ${mediaQuery.xxsmall(`
        margin-left: 22px;
    `)}

    h5 {
        font-size: 18px; 
        ${mediaQuery.large(`
            font-size: 16px;
        `)}

        font-weight: bold; 
        font-family: ${definitions.fonts.heading};
    }

    &:before {
        display: inline-block;
        position: absolute;
        content: '';

        left: -25px;
        bottom: 7px;

        width: 15px;
        height: 15px;

        border-radius: 7.5px;
        
        background-color: ${props => props.statusColor};
    }
`;